import { render, staticRenderFns } from "./project_bidding.vue?vue&type=template&id=874bca08&scoped=true&"
import script from "./project_bidding.vue?vue&type=script&lang=js&"
export * from "./project_bidding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874bca08",
  null
  
)

export default component.exports